export const ExportAction = ({ onExport }) => ({
  label: "Export",
  icon: "export-sheet",
  onClickBulk: onExport,
  confirm: {
    title: "Export Launches",
    message: (selection = []) =>
      `Export ${selection.length} selected launch${
        selection.length === 1 ? "" : "es"
      }?`,
    confirmLabel: "Export",
  },
})
